/*
 * Jira Ticket:
 * Created Date: Wed, 22nd Apr 2020, 19:24:34 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { Labeled } from 'react-admin';
import { imageArrayStyles } from 'styles';

const ImageArray = ({ label, record, setLightBoxOnImgClick, translate }) => {
  const classes = imageArrayStyles();
  const imageFieldArray = [];
  if (record && record.images && record.images.length > 0) {
    for (let i = 0; i < record.images.length; i++) {
      const image = record.images[i];
      imageFieldArray.push(
        <div key={`${image.id}-container-div`} className={classes.container}>
          <img
            key={image.id}
            className={classes.image}
            src={image.url}
            alt={'inspection'}
            onClick={() => setLightBoxOnImgClick(i)}
            role="button"
          />
          <div key={`${image.id}-container-div`} className={classes.middle}>
            <div
              key={`${image.id}-container-div`}
              className={classes.text}
              onClick={() => setLightBoxOnImgClick(i)}
            >
              {translate('actions.clickToEnlarge')}
            </div>
          </div>
        </div>
      );
    }
  }
  return (
    <Labeled label={label}>
      <div className={classes.root}>
        {imageFieldArray.length > 0 ? (
          imageFieldArray
        ) : (
          <em className={classes.noImage}>
            {translate('error.imagesNotFound')}
          </em>
        )}
      </div>
    </Labeled>
  );
};

ImageArray.defaultProps = { addLabel: true };

export default ImageArray;
